/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MergeProfileData } from './MergeProfileData';
export type MergeProfileSave = {
  secondary_id: number;
  primary_data?: MergeProfileData;
  secondary_data?: MergeProfileData;
  move_companies?: MergeProfileSave.move_companies | null;
  move_issuer_names?: MergeProfileSave.move_issuer_names | null;
  delete_secondary?: boolean;
};
export namespace MergeProfileSave {
  export enum move_companies {
    TO_PRIMARY = 'to_primary',
    TO_SECONDARY = 'to_secondary',
  }
  export enum move_issuer_names {
    TO_PRIMARY = 'to_primary',
    TO_SECONDARY = 'to_secondary',
  }
}

